((win) => {
  const templateStyle = `
    <style>
        .popup {
            min-width: 40%; !important;
        }
        /*
         當螢幕寬度 為 600px 以上 則套用以下樣式
         */
        @media (min-width: 600px) {
            .popup {
                max-width: 40%; !important;
                /*  垂直置中  */
                position: fixed;
                top: 18%;
                left: 36%;
            }
        }

        .popup p  {
            margin-left: 10px; !important;
            margin-right: 10px; !important;
        }
    </style>
  `
  const createTemplate = () => {
    return `
    <link rel="stylesheet" href="../../../css/reset.css">
    <link rel="stylesheet" href="../../../css/header.css">
    <link rel="stylesheet" href="../../../css/all.css">
    ${templateStyle}
    <div class="popup">
          <div class="content">
            <h1>請重新登入會員</h1>
            <p>偵測到需更新會員資料，點擊確認將登出，並請重新登入會員。</p>
            <p></p>
            <div class="btn">
              <a href="#" ><span id="closeModal">確定</span></a>
            </div>
          </div>
     </div>
    `
  }

  customElements.define('lock-account-pop', class extends HTMLElement {
    constructor() {
      super()
      this.attachShadow({ mode: 'open' })
      this.shadowRoot.innerHTML = createTemplate()
      this.addEventListeners()
    }

    addEventListeners(){
      const closeModal = this.shadowRoot.getElementById("closeModal")
      if (closeModal) {
        closeModal.addEventListener("click", (e) => {
          e.preventDefault()
          win.logout()
        })
      }
    }
  })
})(window)
